import { ePHTRAbi } from 'abis/ePHTR'
import { NetworkType } from 'abis/set/sets'
import Big from 'big.js'
import { atom } from 'jotai'
import { atomsWithQuery } from 'jotai-tanstack-query'
import { ePHTR } from 'products'
import { QUERY_KEY_PRICE } from 'services/query-v2/keys'
import { DEFAULT_REFETCH_INTERVAL } from 'services/query-v2/refetch-intervals'
import { viemPublicClients } from 'services/wallet/chains'
import { convertAmountToWei, formatWeiToAmount } from '../../../utils/numbers-helper'
import { createAtomsWithQuery } from '../atomic-factory'
import {
  defaultPriceRequest,
  getPHTRUSDPrice,
  parseEPHTRQuotePrice,
  PriceRequest,
  PriceRequestAtoms,
  PriceResponse,
} from './model'

export const [phtrPrice, phtrResponse] = atomsWithQuery(() => ({
  queryKey: ['phtrPrice'],
  queryFn: getPHTRUSDPrice,
  refetchInterval: DEFAULT_REFETCH_INTERVAL,
  staleTime: Infinity,
}))

const stakingPriceQuery = async <T>({
  queryKey: [, params],
}: {
  queryKey: [string, PriceRequest]
}) => {
  const PHTRPrice = await getPHTRUSDPrice()

  const tokenAmount = BigInt(convertAmountToWei(Big(1), params.sellCurrency.decimals).toString())

  const withdrawableAmount = await viemPublicClients[NetworkType.Mainnet].readContract({
    address: ePHTR.address,
    abi: ePHTRAbi,
    functionName: 'withdrawableAmount',
    args: [tokenAmount],
  })

  const withdrawableAmountToken = formatWeiToAmount(
    withdrawableAmount.toString(),
    params.sellCurrency.decimals,
  )
  return parseEPHTRQuotePrice(params, Big(PHTRPrice.usd).mul(withdrawableAmountToken)) as T
}

export const stakedPHTRPriceFactory = () => {
  const priceRequestParamsAtom = atom<PriceRequest>(defaultPriceRequest)

  const mainProperties = createAtomsWithQuery<
    PriceResponse,
    PriceRequest,
    null,
    null,
    [string, PriceRequest]
  >(
    { first: priceRequestParamsAtom },
    QUERY_KEY_PRICE,
    stakingPriceQuery<PriceResponse>,
    DEFAULT_REFETCH_INTERVAL,
    'stakingPriceQuery',
  )

  return { params: priceRequestParamsAtom, ...mainProperties } as PriceRequestAtoms
}
